import '../styles.css';
import { mountLearnPage } from '../ui/learn/page.js';
import { INCOME_PAGE } from './income.js';

mountLearnPage(INCOME_PAGE);
